const EMAIL_ALERT_DESCRIPTION_END = " fails validation."
export const EMAIL_ALERT_ENABLED_DESCRIPTION = [
  "You will receive an email when any Expectation on ",
  EMAIL_ALERT_DESCRIPTION_END,
]
export const EMAIL_ALERT_DISABLED_DESCRIPTION = [
  "You will not receive an email when any Expectation on ",
  EMAIL_ALERT_DESCRIPTION_END,
]
